<style lang="scss" src='./AlertList.scss' scoped></style>
<template src="./AlertList.html"></template>

<script>
import TaskDetails from '@/views/task/details/TaskDetails.vue';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'AlertList',
  components:{
    TaskDetails
  },
  props: {
    alerts: {
      required: false,
    },
    loading: {
      required: false,
    },
    orderBy: {
      required: true,
    },
  },
  data() {
    return ({
    });
  },

  computed:{
    ...mapState(['course']),
    alertsSorted: function() {
      const alerts = this.sortAlerts(this.orderBy);
      return alerts;
    },

    isCourseType(){
      if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
      || !this.course.facility_type){
        return true;
      }else{
        return false;
      }
    },
  },

  watch: {
  },

  methods: {

    getThresholdViolation(alert) {
      let valueViolation = null;
      if (alert.sensor) {
        let minMax = "min_";
        let alertType = this.consts.AlertType[alert.alert_type_id];
        if (alert.violation === 'READING_HIGH') {
          minMax = "max_";
        }
        
        let alertKey = alertType.key;
        if(alert.is_night_time && alert.alert_type_id == 'GROUND_TEMPERATURE'){
          alertKey = 'night_temp'
        }

        valueViolation = alert.sensor.threshold[minMax + alertKey];
      } else {
        const threshold = alert.station.thresholds.find(t => t.alert_type_id === alert.alert_type_id);
        if (threshold) {
          valueViolation = alert.violation === 'READING_HIGH' ? threshold.max : threshold.min;
        }
      }
      
      if (valueViolation != null) {
        return this.G_getMeasurement({ val: valueViolation,
                                    uom: alert.alert_type.uom,
                                    addUnit: true, invertUOM: false });
      }

      return '';
    },

    sortAlerts(orderBy) {
      if (! this.G_isEmptyArr(this.alerts)) {
        return this.alerts.sort((a, b) => {
          if (!a[orderBy] && !b[orderBy]) {
            return 0;
          }
          else if (a[orderBy] && !b[orderBy]) {
            return -1;
          } 
          else if (!a[orderBy] && b[orderBy]) {
            return 1;
          } 
          else {
            if (orderBy.includes("time") || orderBy.includes("last")) {
              // Asc
              return String(b[orderBy]).localeCompare(String(a[orderBy]));
            } else {
              // Desc
              return String(a[orderBy]).localeCompare(String(b[orderBy]));
            }
          }
          return -1;
        });
      } else {
        return [];
      }
    },

  },

  beforeCreate() {},

  created() {},

  mounted() {
  },

  beforeDestroy(){}
};
</script>
